module.exports = __webpack_public_path__ + "img/cliente08.d5a33d97.jpg";